import * as React from 'react';
import {styled} from '@packages/utilities/styled';

export const InputWrapperView = styled('div')(
  ({theme}) => ({
    alignItems: 'stretch',
    backgroundColor: theme.TextInput.background,
    borderColor: theme.TextInput.borderColor,
    borderRadius: theme.control.borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    display: 'flex',
    flex: '0 1 auto',
    height: theme.control.height,
    position: 'relative',
  }),
  {
    hover: ({theme, disabled}) => {
      if (disabled) {
        return {
          borderColor: theme.colors.border,
        };
      }

      return {
        borderColor: theme.TextInput.borderColorHover,
      };
    },

    focus: ({theme, style}) => {
      const styles = style;

      styles.borderColor = theme.colors.accent;

      return styles;
    },

    disabled: ({theme}) => ({
      color: theme.TextInput.disabled.color,
      backgroundColor: theme.TextInput.disabled.background,
      borderColor: theme.colors.border,
      boxShadow: 'none',
    }),

    invalid: ({theme: {focusColors}}) => ({
      color: focusColors.errorTextColor,
      boxShadow: focusColors.errorShadow,
      borderColor: 'transparent',
    }),

    warning: ({theme: {focusColors}}) => ({
      color: focusColors.warningTextColor,
      boxShadow: focusColors.warningShadow,
      borderColor: 'transparent',
    }),
  }
);

export const InputWrapper = React.forwardRef<HTMLDivElement, any>(
  (props, ref) => {
    return <InputWrapperView data-legacy-ds="Input" {...props} ref={ref} />;
  }
);
